<template>
  <div>
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h4>{{ $t('active-sessions') }}</h4>
          <b-button
            :disabled="onDeleteAllLoading"
            variant="danger"
            @click="onDeleteAll"
          >
            <span v-if="!onDeleteAllLoading"> {{ $t('remove-all') }}</span>
            <b-spinner
              v-else
              small
              size="10"
              variant="light"
              type="grow"
            />
          </b-button>
        </div>
        <b-row>
          <b-col
            v-for="activeSession in activeSessions"
            :key="activeSession.id"
            sm="4"
          >
            <activeSessionsCard
              :active-session="activeSession"
              @delete="onDelete"
            />
          </b-col>
        </b-row>
      </b-card>
    </b-overlay>
  </div>
</template>
<script>
import activeSessionsCard from '@/views/theme1/components/activeSessionsCard.vue'
import activeSessions from '@/views/logics/profile/activeSessions'

export default {
  components: {
    activeSessionsCard,
  },
  mixins: [activeSessions],
}
</script>
